import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Grid } from "@mui/material";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import useQueryParams from "../../hooks/use-query-params";
import request from "../../utils/request";
import Icon from "../../components/icon";
import Flex from "../../components/flex";
import googleWorkspace from "../../assets/icons/google-workspace";

const H1 = styled.h1`
    font-size: 22px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const GoogleOauth = () => {
    const query = useQueryParams();
    const navigate = useNavigate();

    const integrateMethod = async () => {
        const code = query.get("code");

        if (!code) navigate("/integrations");

        try {
            await request(`/api/google/oauth?code=${code}`);
            localStorage.setItem("cidt", new Date().valueOf().toString());
            navigate("/integrations/success/google");
        } catch (e) {
            navigate("/integrations/failure/google");
        }
    };

    React.useEffect(() => {
        integrateMethod();
    }, [query]);

    return (
        <>
            <Helmet>
                <title>Adadot - Finalising Google Integration</title>
            </Helmet>
            <Box mt={10}>
                <Grid
                    container
                    spacing={3}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Grid item>
                        <Icon svg={googleWorkspace} width="250px" height="auto" />
                    </Grid>
                    <Grid item style={{ textAlign: "center" }}>
                        <H1>Plugging in Google</H1>
                        <Span>You will be redirected momentarily</Span>
                    </Grid>
                    <Grid item style={{ marginTop: "40px" }}>
                        <Flex justifyContent="center">
                            <CircularProgress size={50} />
                        </Flex>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default GoogleOauth;
